// extracted by mini-css-extract-plugin
export var orderSummary = "_lz-0";
export var showMoreLessButton = "_lz-1";